import $ from "jquery";
import "bootstrap";

"use strict";

$.fn.uly_wizard = function(options, param) {
    if (typeof options === "string") {
        var method = options;
        var args = Array.prototype.slice.call(arguments, 1);
        var returnVals = [];
        this.each(function() {
            var wizard = $(this).data("uly_wizard");
            if (wizard && typeof wizard[method] === "function") {
                return returnVals.push(wizard[method].apply(this, args));
            }
            else {
                throw new Error("Method " + method + " does not exist on $.uly_wizard");
            }
        });
        if (this.length === 1) {
            if(!returnVals.length)
                return null;
            return returnVals[0];
        }
        return returnVals;
    }
    else if (typeof options === "object" || !options) {
        return this.each(function() {
            var wizard = $(this).data("uly_wizard");
            if (!wizard) {
                wizard = new Wizard(this, options);
                $(this).data("uly_wizard", wizard);
            }
            return wizard;
        });
    }
};

$.fn.uly_wizard.defaults = {
    currentStep: 1,
    addButtons: true,
    sidebar: ".bs-wizard-sidebar",
    activeClass: "bs-wizard-active",
    activeStep: "bs-wizard-stepactive",
    completedClass: "bs-wizard-completed",
    todoClass: "bs-wizard-todo",
    stepClass: "bs-wizard-step",
    nextText: "Next Step",
    backText: "Go Back",
    nextType: "submit",
    backType: "reset",
    nextClasses: "btn btn-primary",
    backClasses: "btn btn-default",
    beforeNext: function() {
        return true;
    },
    onNext: function() {
        return true;
    },
    beforeBack: function() {
        return true;
    },
    onBack: function() {
        return true;
    },
    onHide: function() {
        return true;
    },
    onShow: function() {
        return true;
    },
    onInit: function() {
        return true;
    },
    onDestroy: function() {
        return true;
    }
};

function Wizard(element, options) {
    var wizard = this;
    var $el = $(element);
    var $current_step = null;
    var current_step_index = -1;

    $.extend(this, {
        init: function() {
            if (options.addButtons) {
                this.add_buttons();
                $("." + options.stepClass, $el).children("button[type='" + options.nextType + "']").click(this.go_next);
                $("." + options.stepClass, $el).children("button[type='" + options.backType + "']").click(this.go_prev);
            }
            this.show_step(0);
            return this.hook("onInit", this);
        },
        add_buttons: function() {
            var all_steps, ix, last, nextBack, nextOnly, _results;
            nextOnly = $("<div/>", {
                "class": options.stepClass
            }).append($("<button/>", {
                "class": options.nextClasses,
                type: options.nextType,
                text: options.nextText
            }));
            nextBack = $("<div/>", {
                "class": options.stepClass
            }).append($("<button/>", {
                "class": options.backClasses,
                type: options.backType,
                text: options.backText
            })).append(" ").append($("<button/>", {
                "class": options.nextClasses,
                type: options.nextType,
                text: options.nextText
            }));
            all_steps = $(".bs-step .bs-step-inner form", $el);
            if (all_steps.length === 0) {
                all_steps = $(".bs-step .bs-step-inner", $el);
            }
            last = all_steps.length - 1;
            ix = 0;
            _results = [];
            while (ix < last) {
                if (ix === 0) {
                    $(all_steps[0]).append(nextOnly);
                } else {
                    $(all_steps[ix]).append($(nextBack).clone());
                }
                _results.push(ix++);
            }
            return _results;
        },
        show_step: function(step) {
            if (!step && step !== 0) {
                step = null;
            }
            var all_steps = $(".bs-step", $el);
            var current_step_index = all_steps.index(all_steps.filter("."+options.activeStep));
            var current_step = current_step_index >= 0 ? $(all_steps[current_step_index]) : null;
            if (step === null) {
                step = current_step_index;
                if (step < 0) step = 0;
            }
            if (step >= 0 && step < all_steps.length) {
                //ensure non-active steps are hidden
                if (current_step)
                    all_steps.not(current_step).removeClass(options.activeStep).hide();
                else all_steps.removeClass(options.activeStep).hide();
                //transition
                var new_step = $(all_steps[step]);
                if (current_step_index >= 0 && step != current_step_index) {
                    wizard.hook("onHide", current_step, current_step_index, new_step, step);
                    if (options.hide_func) 
                        options.hide_func(current_step);
                    else current_step.hide();
                    current_step.removeClass(options.activeStep);
                }
                if (new_step) {
                    wizard.hook("onShow", new_step, step);
                    if (options.show_func)
                        options.show_func(new_step);
                    else new_step.show();
                    new_step.addClass(options.activeStep);
                }
                $(options.sidebar, $el).children("li." + options.todoClass).removeClass(options.activeClass);
                return $($(options.sidebar, $el).children("li." + options.todoClass)[step]).addClass(options.activeClass);
            }
        },
        current_step: function() {
            var all_steps = $(".bs-step", $el);
            return all_steps.index(all_steps.filter("."+options.activeStep));
            
        },
        current_panel: function() {
            var all_steps = $(".bs-step", $el);
            return all_steps.filter("."+options.activeStep);
        },
        go_next: function(ev) {
            if (ev) {
                ev.preventDefault();
            }
            var panel = wizard.current_panel();
            var new_step = -1;
            if (panel.length) {
                var hook_res = wizard.hook("beforeNext", panel);
                if (hook_res === false)
                    return null;
                if (hook_res >= 0 && hook_res !== true)
                    new_step = hook_res;
            }
            var current_step = wizard.current_step();
            if (new_step === -1)
                new_step = current_step + 1;
            var new_panel = $(".bs-step", $el)[new_step];
            if (new_step != current_step) {
                if (current_step >= 0)
                    $($(options.sidebar, $el).children("li." + options.todoClass)[current_step]).addClass(options.completedClass);
                console.log("showing:", new_step, " from:", current_step);
                wizard.show_step(new_step);
                return wizard.hook("onNext", panel);
            }
            return null;
        },
        go_back: function(ev) {
            if (ev) {
                ev.preventDefault();
            }
            var panel = wizard.current_panel();
            var new_step = -1;
            if (panel.length) {
                var hook_res = wizard.hook("beforeBack", panel);
                if (hook_res === false)
                    return;
                if (hook_res >= 0 && hook_res !== true)
                    new_step = hook_res;
            }
            var current_step = wizard.current_step();
            if (new_step === -1)
                new_step = current_step - 1;
            var new_panel = $(".bs-step", $el)[new_step];
            if (new_step != current_step) {
                wizard.show_step(new_step);
                return wizard.hook("onBack", panel);
            }
        },
        destroy: function() {
            if (!wizard.hook("onDestroy")) {
                return;
            }
            return $.data(this, "uly_wizard", null);
        },
        hook: function hook(method) {
            if (options[method]) {
                var fn = options[method];
                arguments[0] = $el;
                return fn.apply(this, arguments);
            }
        }
    });
    
    options = $.extend({}, $.fn.uly_wizard.defaults, options);
    this.init();
    //return this;
}
